module.exports = __webpack_public_path__ + "static/tab_me_select.0937e140.png";